import { render, staticRenderFns } from "./results_empty.vue?vue&type=template&id=0e2518a4&scoped=true"
import script from "./results_empty.vue?vue&type=script&lang=js"
export * from "./results_empty.vue?vue&type=script&lang=js"
import style0 from "./results_empty.vue?vue&type=style&index=0&id=0e2518a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2518a4",
  null
  
)

export default component.exports